import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import {  LargeButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { ERAISED_LARGE_BUTTONS_LIST, RAISED_LARGE_BUTTONS } from "../../../../Data/Buttons/RaisedStyle";

const RaisedLargeButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={LargeButton} span={RAISED_LARGE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="lg" color="primary" className="btn-pill btn-air-primary" id="Tooltip-8">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-8" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary btn-air-primary btn-lg</ToolTip>
          {ERAISED_LARGE_BUTTONS_LIST.map((data, index) => (
            <CommonRaisedButton key={index} item={data} size="lg" />
          ))}
        </CardBody>
      </Card>
    );
};

export default RaisedLargeButtons;
